export default __webpack_public_path__ + "static/media/fb-stick.f705804d.svg";